"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServiceTemplateMapper = updateServiceTemplateMapper;
const domain_1 = require("@home-health-notify/domain");
function updateServiceTemplateMapper(template, additionalData) {
    const { chatInfo } = additionalData;
    let updatedTemplateData = Object.assign({}, template);
    if (chatInfo) {
        const services = [];
        const groupChatInfo = chatInfo;
        if (groupChatInfo === null || groupChatInfo === void 0 ? void 0 : groupChatInfo.servicesToPatient) {
            groupChatInfo.servicesToPatient.forEach(service => {
                const serviceStatus = service.status;
                if (serviceStatus !== domain_1.SERVICE_STATUS.END_OF_CARE) {
                    services.push({
                        service: service.shorthand,
                        status: Number(serviceStatus),
                    });
                }
            });
        }
        updatedTemplateData = Object.assign(Object.assign({}, updatedTemplateData), { initialData: {
                services,
            } });
    }
    return updatedTemplateData;
}
